import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAPI } from '../../utils/api';
import { FaEnvelope, FaLock } from "react-icons/fa";
import logo from '../../assets/images/logo.png';
import Input from '../../components/Input/Input';
import PasswordInput from '../../components/Input/PasswordInput';
import CommonButton from '../../components/CommonButton/CommonButton';
import Toast from '../../components/Toast/Toast';
import './Login.css';
import { setUserData } from '../../store/slices/userState';
import { useDispatch } from 'react-redux';
import { requestForToken } from '../../utils/firebase';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    token: ''
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, type: '', message: '' });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ show: false, type: '', message: '' });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [toast.show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setToast((prev) => (prev.show ? { show: false, type: '', message: '' } : prev));
  };

  const validateForm = () => {
    if (!formData.email?.trim()) {
      setToast({ show: true, type: 'error', message: 'Email is required' });
      return false;
    }
    if (!formData.password?.trim()) {
      setToast({ show: true, type: 'error', message: 'Password is required' });
      return false;
    }
    if (!formData.email?.includes('@')) {
      setToast({ show: true, type: 'error', message: 'Please enter a valid email address' });
      return false;
    }
    if (formData.password?.length < 6) {
      setToast({ show: true, type: 'error', message: 'Password must be at least 6 characters long' });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    // setLoading(true);
    setToast({ show: false, type: '', message: '' });

    try {
      const token = await requestForToken();
      console.log("Token",token)
      formData.token = token;
      const response = await loginAPI(formData);
      console.log("response",response)
      if (response.status === 200 && response?.token) {
        setToast({ show: true, type: 'success', message: 'Login successful! Redirecting...' });
        localStorage.setItem('adminToken', response?.token);
        localStorage.setItem('adminData', JSON.stringify(response?.data || {}));
        dispatch(setUserData(response?.data || {}));
        
        if (response?.data?._id) {
          localStorage.setItem('userId', response?.data?._id);
        }
        
        setTimeout(() => {
          navigate('/dashboard');
        }, 1000);
      } else {
        setToast({ show: true, type: 'error', message: response.message || 'Login failed' });
      }
      
    } catch (err) {
      setToast({ show: true, type: 'error', message: err.message || 'Network error. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-icon">
            <img src={logo} alt="Yoella Logo" className="login-logo-image" />
          </div>
          <h2>Admin Portal</h2>
          <p>Secure access for administrators only</p>
        </div>

        <Toast toast={toast} />

        <form onSubmit={handleSubmit} className="login-form">
          <Input
            title="Email Address"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            placeholder="Enter your email address"
            required
            disabled={loading}
            icon={<FaEnvelope />}
          />

          <PasswordInput
            title="Password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            placeholder="Enter your password"
            required
            disabled={loading}
            icon={<FaLock />}
          />

          <CommonButton
            type="submit"
            variant="primary"
            size="large"
            fullWidth
            loading={loading}
            onClick={handleSubmit}
          >
            Sign In
          </CommonButton>
        </form>
      </div>
    </div>
  );
}

export default Login; 